import { useRefListener, useWidget } from '../../../widget/sgwt-configuration';
import { IcClientLegalEntityModel } from './IcAccountModel';
import { v4 as uuidv4 } from 'uuid';

export interface IcAccountsElementaryClientJsonSchemaWidgetProps {
  onChange: (newValues: IcClientLegalEntityModel[]) => void;
  value: IcClientLegalEntityModel[];
  readonly: boolean;
}

export const IcAccountsElementaryClientJsonSchemaWidget = ({
  onChange,
  value,
  readonly = false,
}: IcAccountsElementaryClientJsonSchemaWidgetProps): JSX.Element => {
  useWidget('https://shared.sgmarkets.com/ic-widgets/v1/ic-account-multi-picker');

  const handleChange = (event: CustomEvent): void => {
    if (event.detail.accounts) {
      onChange(
        event.detail.accounts.map((account: IcClientLegalEntityModel) => {
          const { icId, name, bdrLegalId, bdrMnemonic } = account;
          return { icId, name, bdrLegalId, bdrMnemonic };
        })
      );
    } else {
      onChange([]);
    }
  };

  const ref = useRefListener<CustomEvent>('ic-account-multi-picker--changed', handleChange);

  const selectedIds =
    value && Array.isArray(value) ? `[${value.map((account: IcClientLegalEntityModel) => account.icId).join()}]` : '[]';

  return readonly ? (
    <ic-account-multi-picker ref={ref} id={uuidv4()} placeholder={''} readonly-ids={selectedIds} levels={'["EC"]'} />
  ) : (
    <ic-account-multi-picker
      ref={ref}
      id={uuidv4()}
      placeholder={''}
      max-result-count={100}
      selected-ids={selectedIds}
      levels={'["EC"]'}
    />
  );
};
